var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-img',{staticClass:"klaklouk-img",attrs:{"src":_vm.findImageOfEachKlaklouk(_vm.item.bet_type.name),"width":"35"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }